

import React from 'react';
import Navbar from '../components/navbar';
import { Helmet } from '@dr.pogodin/react-helmet';
import "../css/admin.css";
const Pickup = () => {
    return (
        <>
            <Helmet>
                <title>Pickup</title>
            </Helmet>
            <Navbar />
            <div className="page-container">

                <div className="page-content">
                    <h1 className="page-title">Candle Pickup</h1>

                    <div className="info-card">
                        <h2 className="info-card-title">Pickup Location</h2>
                        <p className="info-card-text">
                            Candles will be available for pickup on campus. When you arrive, please let us know the
                            name and email used for your order so we can look it up.
                        </p>

                        <div className="info-section">
                            <div className="info-label">Building</div>
                            <div className="info-value">St. Mary's</div>
                        </div>

                        <div className="info-section">
                            <div className="info-label">Location</div>
                            <div className="info-value">St. Mary's Coffee Bar</div>
                        </div>

                        <div className="info-section">
                            <div className="info-label">When</div>
                            <div className="info-value">Decemeber 9–10 from 10am–5:00pm</div>
                        </div>

                        <p className="info-card-note">
                            If you cannot pickup within the designated time frame, please email us at <a href='mailto:info@soleminstries.org'>info@soleminstries.org</a> or message Nick or Hector in the <a href='https://discord.gg/8kUtNREn4D'>Discord</a>.
                            If you can, please email or send a message in advance so we know when to expect you. Thanks!
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Pickup;